// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { ActivitySubmissionFileWrapper } from "./activity-submission-file.styles";

export const ActivitySubmissionFile: FunctionComponent<{ source: string }> = ({ source }) => {
    return <ActivitySubmissionFileWrapper dangerouslySetInnerHTML={{ __html: `<img src=${source} />` }} />;
};
